<template>
  <div style="width: 90vw">
    <el-container class="contain-6" style="padding: 25px 25px">


      <div class="bbb">
        <el-header style="display: flex;height: 40px;">

          <span class="style-title">项目名称:{{ this.$router.query }}</span>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsGame"
                :key="item"

                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <span class="style-title">投放方式:</span>
          <el-select v-model="agencyUid" placeholder="方式选择" size="mini"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsagencyUid"
                :key="item"

                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <span class="style-title">日期:</span>
          <el-date-picker

              @change="searchChage"
              style="margin-left: 5px;margin-top: 5px;width: 180px;align-items: center;display: flex"
              v-model="value2"
              align="right"
              type="date"

              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              size="mini"
              :picker-options="pickerOptions">
          </el-date-picker>
          <span class="style-title">广告id:</span>
          <el-input v-model="advertiserId" placeholder="请输入广告id" size="mini" clearable
                    style="margin-left: 5px;margin-top: 5px;width: 200px;align-items: center;display: flex">

          </el-input>


          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="search(true)" icon="el-icon-refresh">
            刷新
          </el-button>

          <!--          <download-excel style="margin-left: 2px" :data="json_data"-->
          <!--                          :fields="json_fields"-->
          <!--                          name="数据.xls" :fetch="createExportData">-->
          <!--            <el-button size="mini"-->
          <!--                       style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black;">下载表格-->
          <!--            </el-button>-->
          <!--          </download-excel>-->


        </el-header>
        <el-table
            ref="tableData1"
            :data="tableData"
            stripe
            border
            :max-height="maxHeight"
            style="margin-top: 11px"
            :header-cell-style="{background:'rgb(244,244,245)',color:'#323335'}"
            size="mini"
            v-loading="loading"
            highlight-current-row
        >

          <el-table-column
              align="center"
              type="selection"
              width="44">
          </el-table-column>
          <el-table-column
              prop="date"
              label="广告名称"
              min-width="380"
              fixed
              show-tooltip-when-overflow
          >
            <template slot-scope="scope">

              <div style="color: black">{{ scope.row.aname }}</div>
              <div style="color: #969AA0">id:{{ scope.row.campaignId }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agencyUid"
              label="方式"
              width="120"
              fixed

          >
            <template slot-scope="scope">

              <span v-if="scope.row.agencyUid==null">-</span>

              <span v-else>
              <span v-if="scope.row.agencyUid=='自动投放'"
                    style="color: #2E95FB;font-size: 12px;font-family: 微软雅黑,serif">{{ scope.row.agencyUid }}</span>

              <span v-else style="color: #5daf34;font-size: 12px;font-family: 微软雅黑,serif">{{
                  scope.row.agencyUid
                }}</span>
                </span>
            </template>


          </el-table-column>

          <el-table-column
              prop="CAmount"
              label="实际消耗"
              fixed
              :formatter="value_format"
          >

          </el-table-column>
          <el-table-column
              prop="realPei"
              label="实际赔付"
              fixed
              :formatter="value_format"
          >

          </el-table-column>
          <el-table-column
              prop="validClickCount"
              label="出价消耗"
              fixed

          >
            <template slot-scope="scope">
              <span v-if="scope.row.agencyUid=='手动投放'">
              {{
                  scope.row.validClickCount * scope.row.payCount === 0 ? '-' : scope.row.validClickCount * scope.row.payCount
                }}
                </span><span v-else>  {{ scope.row.conversionsCount }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="active"
              label="预估赔付"
              width="180"
              fixed
          >
            <template slot-scope="scope">
            <span v-if="scope.row.active===5||scope.row.active===6||scope.row.active===7"><svg t="1732779186315"
                                                                                               class="icon"
                                                                                               style="width: 20px;height: 20px"
                                                                                               viewBox="0 0 1024 1024"
                                                                                               version="1.1"
                                                                                               xmlns="http://www.w3.org/2000/svg"
                                                                                               p-id="4732" width="200"
                                                                                               height="200"><path
                d="M514.70818 1006.180146c-60.347436-93.039-153.574724-132.704394-248.914116-162.359808C108.088252 794.751782 64.405357 669.954475 79.49196 520.213056c6.024204-59.820434 16.871249-119.359458 29.011754-178.308035 15.980973-77.590146-12.169157-145.388275-40.643676-213.95286-7.04751-16.972557-28.379351-36.44198-0.450255-52.881394 28.773324-16.947997 42.012859-65.074088 91.163279-42.139749 112.093984 52.324716 224.630037 53.824883 337.142553-1.031493 10.305717-5.02034 27.309996-5.03569 37.614689-0.008186 112.502283 54.856375 225.321792 53.937446 336.931752 0.62831 35.062564-16.754592 48.626487 8.752338 70.187549 22.75833 33.073256 21.467941 38.912242 45.008077 18.116613 80.513732-58.543348 99.968829-38.429241 204.539466-19.651572 311.302025 11.661597 66.275449 11.787464 136.675846 4.107551 203.742311-9.487072 82.780355-58.140165 143.69675-137.814786 175.730327-24.14798 9.711176-49.045019 17.584494-73.03541 27.64871C649.865439 888.748596 566.697251 922.231175 514.70818 1006.180146zM642.614292 454.526007c-7.836479-42.832528-7.836479-42.832528 29.756721-44.975331 71.066569-4.070712 95.012957-29.059849 95.697549-100.291171 0.25071-26.110681-0.983397-52.269457 0.210801-78.323856 1.160429-25.28078-9.815553-33.386388-34.287921-32.977066-65.951061 1.128707-131.936915 0.355087-197.910489 0.355087-110.875227-0.008186-110.875227 0-110.875227 111.62224 0 93.553723 0.052189 92.89369 95.583962 100.669794 10.517541 0.854461 19.974937 14.706957 29.919427 22.532179-10.556427 7.107885-20.812001 19.767206-31.728632 20.363793-43.38409 2.368954-86.977957 0.975211-132.154879 0.975211 0 21.307282 0 36.772508 0 53.309136 24.477484 1.490957 45.966914 2.802836 71.460542 4.359284-3.869121 51.045583-24.49488 90.645486-53.168943 128.576377-12.534478 16.585747-16.427134 39.697117-24.243147 59.844993 102.882182-27.085892 138.477888-101.983719 161.319106-189.630918 7.145747 15.818267 9.243525 29.865191 9.380648 43.928488 0.49528 50.850132 1.131777 101.724823 0.124843 152.551418-0.644683 32.443923 18.887163 33.307593 43.163055 33.476439 25.228591 0.168846 42.567491-2.910283 41.575908-34.910091-1.620917-52.173267-0.595564-104.442724-0.173962-156.663062 0.100284-12.554944 2.212388-25.087375 3.400446-37.625946 4.174066-1.539053 8.348132-3.079128 12.527314-4.618181 15.251356 92.103698 54.680367 164.67248 141.016711 199.350281 5.13802-2.844791 10.279111-5.697769 15.416108-8.544607-28.430516-59.868529-56.862056-119.736035-89.339748-188.122565 27.226085 0 39.386032-0.338714 51.52449 0.071631 19.046798 0.644683 35.861766 0.475837 36.048007-26.359344 0.200568-28.553313-17.467837-29.350468-38.3484-29.100782C726.239897 454.880071 683.959955 454.526007 642.614292 454.526007zM285.732162 402.442792c0 101.805664 0.608867 197.834764-0.366344 293.838282-0.294712 29.083385 4.318352 45.610804 40.144302 45.321208 34.383088-0.273223 45.556569-11.313673 45.057195-45.144176-1.523703-103.104239-2.494821-206.296483 0.430812-309.335231 1.220804-43.00956 11.995195-85.881996 19.99438-128.530328 4.669346-24.909319 12.443403-49.230238 18.797112-73.745584-64.429405-16.745383-67.801199-10.54824-88.766696 40.060391-19.458167 46.974871-51.314713 88.719624-76.268034 133.574205-9.091052 16.335037-14.011108 34.983769-20.836561 52.583612 3.927449 1.998517 7.856945 3.997034 11.785417 5.995551C249.766019 412.951123 263.828292 408.840502 285.732162 402.442792zM685.78758 253.750261c1.608637 12.361539 2.7486 17.735943 2.937912 23.144116 2.443655 68.475558-0.151449 71.086012-69.688175 71.118757-19.24839 0.016373-38.496779 0.023536-57.744145 0-52.894697-0.056282-73.315796-28.850072-54.841026-79.539544 2.393513-6.560416 13.519921-13.917988 20.754696-14.086833C579.119165 253.185396 631.069351 253.750261 685.78758 253.750261z"
                fill="#09954d" p-id="4733"></path></svg>
            </span>
              <span v-else><svg t="1732779186315" style="width: 20px;height: 20px" class="icon" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4732" width="200" height="200"><path
                  d="M514.70818 1006.180146c-60.347436-93.039-153.574724-132.704394-248.914116-162.359808C108.088252 794.751782 64.405357 669.954475 79.49196 520.213056c6.024204-59.820434 16.871249-119.359458 29.011754-178.308035 15.980973-77.590146-12.169157-145.388275-40.643676-213.95286-7.04751-16.972557-28.379351-36.44198-0.450255-52.881394 28.773324-16.947997 42.012859-65.074088 91.163279-42.139749 112.093984 52.324716 224.630037 53.824883 337.142553-1.031493 10.305717-5.02034 27.309996-5.03569 37.614689-0.008186 112.502283 54.856375 225.321792 53.937446 336.931752 0.62831 35.062564-16.754592 48.626487 8.752338 70.187549 22.75833 33.073256 21.467941 38.912242 45.008077 18.116613 80.513732-58.543348 99.968829-38.429241 204.539466-19.651572 311.302025 11.661597 66.275449 11.787464 136.675846 4.107551 203.742311-9.487072 82.780355-58.140165 143.69675-137.814786 175.730327-24.14798 9.711176-49.045019 17.584494-73.03541 27.64871C649.865439 888.748596 566.697251 922.231175 514.70818 1006.180146zM642.614292 454.526007c-7.836479-42.832528-7.836479-42.832528 29.756721-44.975331 71.066569-4.070712 95.012957-29.059849 95.697549-100.291171 0.25071-26.110681-0.983397-52.269457 0.210801-78.323856 1.160429-25.28078-9.815553-33.386388-34.287921-32.977066-65.951061 1.128707-131.936915 0.355087-197.910489 0.355087-110.875227-0.008186-110.875227 0-110.875227 111.62224 0 93.553723 0.052189 92.89369 95.583962 100.669794 10.517541 0.854461 19.974937 14.706957 29.919427 22.532179-10.556427 7.107885-20.812001 19.767206-31.728632 20.363793-43.38409 2.368954-86.977957 0.975211-132.154879 0.975211 0 21.307282 0 36.772508 0 53.309136 24.477484 1.490957 45.966914 2.802836 71.460542 4.359284-3.869121 51.045583-24.49488 90.645486-53.168943 128.576377-12.534478 16.585747-16.427134 39.697117-24.243147 59.844993 102.882182-27.085892 138.477888-101.983719 161.319106-189.630918 7.145747 15.818267 9.243525 29.865191 9.380648 43.928488 0.49528 50.850132 1.131777 101.724823 0.124843 152.551418-0.644683 32.443923 18.887163 33.307593 43.163055 33.476439 25.228591 0.168846 42.567491-2.910283 41.575908-34.910091-1.620917-52.173267-0.595564-104.442724-0.173962-156.663062 0.100284-12.554944 2.212388-25.087375 3.400446-37.625946 4.174066-1.539053 8.348132-3.079128 12.527314-4.618181 15.251356 92.103698 54.680367 164.67248 141.016711 199.350281 5.13802-2.844791 10.279111-5.697769 15.416108-8.544607-28.430516-59.868529-56.862056-119.736035-89.339748-188.122565 27.226085 0 39.386032-0.338714 51.52449 0.071631 19.046798 0.644683 35.861766 0.475837 36.048007-26.359344 0.200568-28.553313-17.467837-29.350468-38.3484-29.100782C726.239897 454.880071 683.959955 454.526007 642.614292 454.526007zM285.732162 402.442792c0 101.805664 0.608867 197.834764-0.366344 293.838282-0.294712 29.083385 4.318352 45.610804 40.144302 45.321208 34.383088-0.273223 45.556569-11.313673 45.057195-45.144176-1.523703-103.104239-2.494821-206.296483 0.430812-309.335231 1.220804-43.00956 11.995195-85.881996 19.99438-128.530328 4.669346-24.909319 12.443403-49.230238 18.797112-73.745584-64.429405-16.745383-67.801199-10.54824-88.766696 40.060391-19.458167 46.974871-51.314713 88.719624-76.268034 133.574205-9.091052 16.335037-14.011108 34.983769-20.836561 52.583612 3.927449 1.998517 7.856945 3.997034 11.785417 5.995551C249.766019 412.951123 263.828292 408.840502 285.732162 402.442792zM685.78758 253.750261c1.608637 12.361539 2.7486 17.735943 2.937912 23.144116 2.443655 68.475558-0.151449 71.086012-69.688175 71.118757-19.24839 0.016373-38.496779 0.023536-57.744145 0-52.894697-0.056282-73.315796-28.850072-54.841026-79.539544 2.393513-6.560416 13.519921-13.917988 20.754696-14.086833C579.119165 253.185396 631.069351 253.750261 685.78758 253.750261z"
                  fill="#2c2c2c" p-id="4733"></path></svg>
              </span> <span
                v-if="scope.row.active===5||scope.row.active===4||scope.row.active===6||scope.row.active===7"
                style="font-size: 11px"> {{
                scope.row.adBpPlatform === '新信息流' ? '' : scope.row.adBpPlatform.split('|')[0]
              }}<div
                  style="color: #3f3f41;font-size: 11px">  {{
                  scope.row.adBpPlatform === '新信息流' ? '' : scope.row.adBpPlatform.split('|')[1] + '|' + scope.row.adBpPlatform.split('|')[2]
                }}</div>
            </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="viewCount"
              label="预估赔付金额"
              width="130"
              :formatter="value_format"
              fixed

          >

          </el-table-column>
          <el-table-column
              v-for="(item, index) in items"
              :prop="'data.day'+index"

              :key="index+''"
              :label="'ROI '+(index+1)"
              :formatter="format2" width="95"
          >
            <template slot-scope="scope">

              <span style="color:#564837;font-family: Arial,serif"
                    v-if="Object.prototype.hasOwnProperty.call(scope.row, 'data3')">

                <span v-if="scope.row.active===5">
                   {{
                    scope.row.data3['day' + (index)] == null ? '-' : ((scope.row.data3['day' + (index)] / (scope.row.validClickCount * scope.row.payCount) * 100)).toFixed(2) + '%'
                  }}

                  </span>
        <span v-else-if="scope.row.active===6||scope.row.active===7">
                         {{
            scope.row.data3['day' + (index)] == null ? '-' : ((scope.row.data3['day' + (index)] / scope.row.cAmount) * 10000).toFixed(2) + '%'
          }}


                </span>
                <span v-else>
                   {{
                    scope.row.data3['day' + (index)] == null ? '-' : ((scope.row.data3['day' + (index)] / scope.row.cAmount) * 10000).toFixed(2) + '%'
                  }}


                </span>
              </span>
              <span v-else>-</span>

            </template>
          </el-table-column>

        </el-table>

        <div class="block">

          <el-pagination
              @current-change="search(true)"
              :current-page.sync="currentPage4"
              :page-size="11"
              layout="total, prev, pager, next"
              :total="size">
          </el-pagination>
        </div>
      </div>


    </el-container>

  </div>
</template>

<script>
export default {
  name: "AdvertisingPyramid",

  data() {

    return {
      tagType: 'primary',
      size: 0,
      items: [],
      optionsagencyUid: ['自动投放', '手动投放'],
      agencyUid: '',
      advertiserId: '',
      maxHeight: 800,
      newPropValue: '',
      valProp2: '',
      valueSuan: '',

      list: [],
      value1: [],
      currentPage: 1,

      valueScene: '',
      fl: false,
      loading: false,
      registerDate: "",
      type: 'pv',
      valueUser: "",
      avgEcpm: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }, pickerOptions2: {
        disabledDate(date) {
          return date.getTime() >= Date.now() - 8.64e7;  //只能选择今天及今天之后的日期，如果没有后面的-8.64e7就是今天也不能选
        }
      },
      tableData: [],
      optionsGame: [],
      openId: "o9SFW5P9jjan0ubjIY6Go-8FdSvE",
      valueGame: this.$router.history.current.query.name,
      options3: [{
        value: '选项1',
        label: '7'
      }, {
        value: '选项2',
        label: '14'
      }, {
        value: '选项3',
        label: '30'
      }],
      option_user: [{id: '新用户', value: '_new'}, {id: '老用户', value: '_old'}, {id: '总用户', value: ''}],
      value: 0,

      ecpmA: 300,
      value2: this.$router.history.current.query.date,
      value3: 7
      , json_data: []
      , json_fields: {},
      headType: '微信默认',
      height: 800,
      arr1: [],
      arr2: [],
      valueGame2: ''

    }


  }, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else if (value < 100) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    },
    numFilter3(value) {
      // 截取当前数据到小数点后两位

      value += ''
      if (!value.includes('.'))
        value += '.'


      return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
        return $1 + ','
      }).replace(/\.$/, '')
    }
  }, methods: {

    indexMethod(index) {

      return index / 6 + 1;

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    }, objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },

    date_format_new() {

      let date1 = new Date();
      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '-' + month + '-' + day;


    },
    createExportData() {

      console.log("下载", this.value1)

      for (let j = 0; j < this.titleHeads.length; j++) {


        this.json_fields[this.titleHeads[j].sta_view_value] = this.titleHeads[j].sta_value
      }


      this.json_data = this.tableData


      return this.json_data

    },


    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    },
    value_format(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = Math.round(value / 100)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else if (value < 5) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, findGame() {

      this.$axios
          .get('/toufang/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    },

    search(flag) {

      if(flag){

        console.log("手动选条件")

        localStorage.setItem("AdvertisingPyramid", JSON.stringify({name: this.valueGame, date: this.value2,campaignId:this.campaignId,currentPage:this.currentPage}))

      }else{
        if (localStorage.getItem("AdvertisingPyramid") != null) {
          console.log("自动刷")

          this.valueGame = JSON.parse(localStorage.getItem("AdvertisingPyramid")).name

          this.value2 = JSON.parse(localStorage.getItem("AdvertisingPyramid")).date

          this.campaignId = JSON.parse(localStorage.getItem("AdvertisingPyramid")).campaignId

          this.currentPage = JSON.parse(localStorage.getItem("AdvertisingPyramid")).campaignId

        }
      }
      this.maxheight = window.innerHeight - 250;

      if (this.value2 != null & this.value2 !== '') {

        this.loading = true
        this.$axios
            .post('/toufang/data/find', {
              start: this.value2 == null ? '' : this.value2,
              cname: this.valueGame == null ? '' : this.valueGame,
              currentPage: this.currentPage4 == null ? 1 : this.currentPage4,
              goodName: this.value3 == null ? '' : this.value3,
              advertserId: '',
              campaignId: this.advertiserId == null ? '' : this.advertiserId,
              agencyId: this.agencyUid == null ? '' : this.agencyUid


            })
            .then(successResponse => {

              this.tableData = successResponse.data.data.data
              this.optionsGame = successResponse.data.data.namelist
              // this.update_pay = successResponse.data.updateTime
              this.size = successResponse.data.data.size
              console.log(this.data)
              console.log('成功')
              // this.querySum()


              this.loading = false
            }).catch((err) => {
          //请求失败的回调函数
          console.log(err)
          console.log('失败')
        })
      }

    },

  }
  , updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  },
  mounted: function () {

    this.height = window.innerHeight;

    if (this.$router.history.current.query.date == null) {

      this.date_format_new()
    }

    for (let i = 0, len = 60; i <= 60; i++) {
      this.items.push(i + '')
    }
    this.search(false)
    this.findGame()
  }


}
</script>
<style>

.style-title {
  font-size: 12px;
  padding: 1px 1px 2px 22px;
  font-family: 微软雅黑, serif;
  font-weight: bold;
  margin-top: 5px;
  line-height: 11px;
  display: flex;
  align-items: center;

}

</style>
<style type="text/css">

*::-webkit-scrollbar {
  width: 13px;
  height: 17px;
  background-color: transparent;
}


.bbb {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 98%;

  min-height: 80vh;
}

</style>

<style scoped>

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

</style>